import React from 'react'

import { Table, Button, Space, Tooltip, Popconfirm } from 'antd'
import { DeleteOutlined, InfoCircleOutlined } from '@ant-design/icons'

const rowKey = (row) => row.id.toString()

const EventList = (props) => {
  const columns = [
    {
      title: 'From ',
      dataIndex: 'date_from',
      key: 'dateFrom',
      width: 100
    },
    {
      title: 'To',
      dataIndex: 'date_to',
      key: 'dateTo',
      width: 100
    },
    {
      title: 'Role',
      dataIndex: 'role',
      key: 'role',
      width: 100,
      render: (type, record) => {
        if (record.vendor) {
          return <>Vendor</>
        }
        if (record.manager) {
          return <>Manager</>
        }
      }
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      elipsis: true,
      render: (type, record) => {
        if (record.vendor) {
          return <>{record.vendor?.name}</>
        }
        if (record.manager) {
          return <>{record.manager?.name}</>
        }
      }
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      width: 140,
      render: (value, record) => {
        if (record.notes) {
          return (
            <Tooltip title={record?.notes}>
              <Space>
                {record.type}
                <InfoCircleOutlined />
              </Space>
            </Tooltip>
          )
        }
        return <>{record.type}</>
      }
    },
    {
      title: 'Action',
      dataIndex: 'date_to',
      width: 140,
      key: 'dateTo',
      render: (algo, record) => {
        return (
          <Popconfirm
            title='Are you sure?'
            onConfirm={() => props.onDismissEvent(record.id)}
            okText='Remove'
            cancelText='No'
          >
            <Button size='small' icon={<DeleteOutlined />} loading={props.isDismissLoading}>
              Dismiss
            </Button>
          </Popconfirm>
        )
      }
    }
  ]

  return (
    <Table columns={columns} dataSource={props.list} size='small' pagination={false} rowKey={rowKey} />
  )
}

EventList.defaultProps = {
  list: [],
  onDismissEvent: async () => {}
}

export default EventList
